import { Loader } from '@hivebrite/design-system/Loader';

import { ApplyMentorForms } from 'hb-react/frontoffice/apps/Mentoring/container/Application/Mentor/ApplyMentorForms';
import { useGetMentorProfileFromUser } from 'hb-react/frontoffice/apps/Mentoring/hooks/useGetMentorProfileFromUser';
import { useGetMentorsCustomAttributes } from 'hb-react/frontoffice/apps/Mentoring/hooks/useGetMentorsCustomAttributes';
import type { Program } from 'hb-react/frontoffice/apps/Mentoring/types';
import { flattenAttributes } from 'hb-react/frontoffice/apps/MyMentoring/utils/flattenAttributesUtils';
import type { User } from 'hb-react/types';

interface ApplicationMentorProps {
  program: Program;
  currentUser: User;
}

export const ApplicationMentor = ({
  program,
  currentUser,
}: ApplicationMentorProps) => {
  const { data: customAttributes, isLoading: isLoadingAttributes } =
    useGetMentorsCustomAttributes({
      program,
      queryConfig: {
        is_displayed_in_mentoring_form: true,
      },
    });
  const { data: mentorProfile, isLoading: isLoadingMentor } =
    useGetMentorProfileFromUser({
      program,
      userId: currentUser.id,
    });

  if (isLoadingAttributes || isLoadingMentor) {
    return <Loader size={40} />;
  }

  const attributes = flattenAttributes(customAttributes);

  return (
    <ApplyMentorForms
      attributes={attributes}
      program={program}
      mentorProfile={mentorProfile}
    />
  );
};
